import { Controller } from "@hotwired/stimulus"

// card-preview — espelha os campos do form de cartão num "preview vivo" que
// mostra como o chip vai aparecer nas listas (nome, emissor · bandeira · ••••)
// e pinta o chip com a cor escolhida em tempo real. Só apresentação; o valor
// da cor persistido vive num hidden_field (colorValue target). CSP-safe.
//
// Uso: data-controller="card-preview" no wrapper, com:
//   - inputs marcados: nameInput, issuerInput, brandInput, lastFourInput, picker
//   - hidden real: colorValue
//   - saída: chip, nameOut, subOut
//   - value: defaultChip (gradiente do tema quando não há cor), nameFallback
export default class extends Controller {
  static targets = [
    "nameInput", "issuerInput", "brandInput", "lastFourInput",
    "picker", "colorValue", "chip", "nameOut", "subOut", "swatch"
  ]
  static values = {
    defaultChip: String,   // gradiente CSS aplicado quando não há cor
    nameFallback: String   // texto do nome quando vazio
  }

  connect() {
    // hasColor deriva do valor já persistido (colorValue não-vazio).
    this._hasColor = this.hasColorValueTarget && this.colorValueTarget.value.trim() !== ""
    this.render()
    this._renderColor()
  }

  // ---- Texto (nome + sub-info) ----
  render() {
    this._renderName()
    this._renderSub()
  }

  _renderName() {
    if (!this.hasNameOutTarget) return
    const val = this.hasNameInputTarget ? this.nameInputTarget.value.trim() : ""
    this.nameOutTarget.textContent = val || this.nameFallbackValue || ""
  }

  _renderSub() {
    if (!this.hasSubOutTarget) return
    const issuer = this.hasIssuerInputTarget ? this.issuerInputTarget.value.trim() : ""
    const brand = this._brandLabel()
    const last = this.hasLastFourInputTarget ? this.lastFourInputTarget.value.trim() : ""
    const parts = [issuer, brand, last ? `•••• ${last}` : ""].filter(Boolean)
    this.subOutTarget.textContent = parts.join(" · ")
  }

  _brandLabel() {
    if (!this.hasBrandInputTarget) return ""
    const el = this.brandInputTarget
    const opt = el.options ? el.options[el.selectedIndex] : null
    return opt && opt.value ? opt.text.trim() : ""
  }

  // ---- Cor ----
  // Escolha via paleta nativa (input[type=color]).
  pickColor() {
    this._hasColor = true
    this._commitColor(this.pickerTarget.value)
  }

  // Preset (swatch): seta a cor e sincroniza o picker.
  preset(event) {
    const c = event.currentTarget.dataset.color
    if (!c) return
    this._hasColor = true
    if (this.hasPickerTarget) this.pickerTarget.value = c
    this._commitColor(c)
  }

  // "Sem cor": volta ao gradiente padrão do tema.
  clearColor() {
    this._hasColor = false
    this._commitColor("")
  }

  _commitColor(hex) {
    if (this.hasColorValueTarget) this.colorValueTarget.value = this._hasColor ? hex : ""
    this._renderColor()
  }

  _renderColor() {
    if (this.hasChipTarget) {
      this.chipTarget.style.background = this._hasColor
        ? this.pickerTarget.value
        : (this.defaultChipValue || "")
    }
    this._syncSwatches()
  }

  _syncSwatches() {
    if (!this.hasSwatchTarget) return
    const cur = this._hasColor && this.hasPickerTarget ? this.pickerTarget.value.toLowerCase() : null
    this.swatchTargets.forEach((s) => {
      const on = cur && (s.dataset.color || "").toLowerCase() === cur
      s.classList.toggle("ring-2", on)
      s.classList.toggle("ring-primary", on)
      s.classList.toggle("ring-offset-2", on)
      s.classList.toggle("ring-offset-background", on)
    })
  }
}
